import apiRequest from '@/service/api/ApiRequestService';

const TeamService = {
    /**
     * Get team information
     */
    async getTeam() {
        return await apiRequest.get('team');
    },

    /**
     * Create a new team
     */
    async createTeam(data) {
        return await apiRequest.post('team', data);
    },

    /**
     * Update team information
     */
    async updateTeam(data) {
        return await apiRequest.put('team', data);
    },

    /**
     * Invite a new team member by email
     */
    async inviteMember(data) {
        return await apiRequest.post('team/invite', data);
    },

    /**
     * Get all invitations
     */
    async getInvitations(status = null) {
        const params = status ? { status } : {};
        return await apiRequest.get('team/invitations', { params });
    },

    /**
     * Resend an invitation by token
     */
    async resendInvitation(token) {
        return await apiRequest.post(`team/invitations/${token}/resend`);
    },

    /**
     * Cancel an invitation by token
     */
    async cancelInvitation(token) {
        return await apiRequest.delete(`team/invitations/${token}`);
    }
};

export default TeamService;

